import { Account } from './account.model';

export class Organization {
  active: boolean;
  createdBy: string;
  id: string;
  name: string;
  constructor(json: any) {
    this.active = json.active;
    this.createdBy = json.createdBy;
    this.id = json.id || json._id;
    this.name = json.name;
  }
}

export class AccountOrganization {
  accountId: Account;
  active: boolean;
  id: string;
  organization: Organization;
  credCount: number;
  reccoCount: number;
  constructor(json: any) {
    this.accountId = json.accountId && new Account(json.accountId);
    this.active = json.active;
    this.id = json.id || json._id;
    this.organization = json.organization && new Organization(json.organization);
    this.credCount = json.credCount;
    this.reccoCount = json.reccoCount;
  }
}
